enum CardFundingType {
    Credit = 'credit',
    Debit = 'debit',
    Prepaid = 'prepaid',
    Unknown = 'unknown',
}

export default CardFundingType;
